import * as React from 'react';
import { DocumentCopyType, PaidBy } from '../../core';

export interface TabItem {
  key: string;
  value: PaidBy | DocumentCopyType;
}

export interface CustomProps {
  tabs: TabItem[];
  tabName: PaidBy | DocumentCopyType;
  tabChangeHandler: (tabName: PaidBy | DocumentCopyType) => void;
  pendingCount?: number;
  requestedCount?: number;
  approvedCount?: number;
  completedCount?: number;
}

const MainTabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<PaidBy | DocumentCopyType>(
    props.tabName
  );

  const setElementActive = (tabValue: PaidBy | DocumentCopyType) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  return (
    <ul
      className="d-flex list-unstyled tab-underline font-sm font-weight-semibold text-nowrap overflow-auto m-0"
      id="activity-tab"
      role="tablist"
    >
      {props.tabs.map((tab) => (
        <li key={tab.key} className="nav-item pr-4 pl-4" role="presentation">
          <a
            className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
              tabName === tab.value ? 'active' : ''
            }`}
            onClick={() => setElementActive(tab.value)}
          >
            <span className="py-1 d-inline-flex">{tab.value}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default MainTabs;
